exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#watermeterCard .v--modal-box.v--modal{min-height:500px!important;min-width:680px!important}#watermeterCard #attr__wrapper .layout:not(#geometry-panel){margin-top:20px}#watermeterCard .v-tabs__div:not(:last-child){padding-right:10px;background-image:linear-gradient(180deg,#2a579a 0,#2a579a),linear-gradient(180deg,#fff 0,#fff);background-clip:content-box,padding-box}#watermeterCard .v-select__selection{font-size:12px!important}#watermeterCard .v-subheader{font-size:14px!important;color:#000!important;font-weight:600!important}.prw-card__watermeters{margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-55051716","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/watermeters/modals/WatermeterCard.vue
// module id = 1745
// module chunks = 0